import {
    GET_TYPE_OF_REPORT, IS_LOADING_GET_TYPE_OF_REPORT, DELETE_REPORT, TYPE_OF_REPORT, IS_LOADING_GET_LIMIT_REPORTS, GET_LIMIT_REPORTS, GET_LIMIT_REPORT
    , IS_LOADING_BANE_LIMITS, GET_BAN_LIMIT_LIST, CREATE_BANE_LIMIT, EDIT_BANE_LIMIT, DELETE_BANE_LIMIT, GET_ACTUAL_LIMIT_BANE, ACTUAL_BANE_LIMIT, IS_LOADING_LIST_REPORTS,
    LIST_REPORTS, CHANGE_REPORT, CREATE_TYPE_OF_REPORT, EDIT_TYPE_OF_REPORT, IS_LOADING_LIST_REPORTS_COMMUNITIES, LIST_REPORTS_COMMUNITIES, CHANGE_REPORT_COMMUNITY, IS_LOADING_LIST_REPORTS_CONTENT, LIST_REPORTS_CONTENT, CHANGE_REPORT_CONTENT, ClEAN_LIST_REPORTS
} from '../actions/types'

const initialState = {
    typeOfReports: [],
    isLoadingTypeOfReports: false,
    typeOfReport: {},
    isLoadingLimitOfReports: false,
    listOfReportsLimit: [],
    reportLimit: {},
    isLoadingBaneLimits: false,
    baneLimitslist: [],
    baneActualLimit: null,
    isLoadingListReports: false,
    listOfReports: [],
    isLoadingListReportsContent: false,
    listOfReportsContent: [],
    isLoadingListReportsCommunities: false,
    listReportsCommunities: []

}

export default function (state = initialState, action) {
    switch (action.type) {

        case GET_TYPE_OF_REPORT:
            return { ...state, typeOfReports: action.payload || [], isLoadingTypeOfReports: false }
        case CREATE_TYPE_OF_REPORT:
            console.log()
            var addTypeReport = Array.from(state.typeOfReports)
            addTypeReport.push(action.payload)
            return { ...state, typeOfReports: addTypeReport, isLoadingTypeOfReports: false }
        case EDIT_TYPE_OF_REPORT:
            console.log()
            var editTypeReport = Array.from(state.typeOfReports)
            editTypeReport[action.payload.index] = action.payload.data
            console.log()
            return { ...state, typeOfReports: editTypeReport, isLoadingTypeOfReports: false }
        case IS_LOADING_GET_TYPE_OF_REPORT:
            return { ...state, isLoadingTypeOfReports: true }
        case DELETE_REPORT:
            var deleteReport = Array.from(state.typeOfReports)
            deleteReport.splice(action.payload, 1)
            return { ...state, isLoadingTypeOfReports: false, typeOfReports: deleteReport }
        case TYPE_OF_REPORT:
            return { ...state, typeOfReport: action.payload }
        case IS_LOADING_GET_LIMIT_REPORTS:
            return { ...state, isLoadingLimitOfReports: true }
        case GET_LIMIT_REPORTS:
            return { ...state, isLoadingLimitOfReports: false, listOfReportsLimit: action.payload }
        case GET_LIMIT_REPORT:
            return { ...state, reportLimit: action.payload }
        case IS_LOADING_BANE_LIMITS:
            return { ...state, isLoadingBaneLimits: true }
        case GET_BAN_LIMIT_LIST:
            return { ...state, baneLimitslist: action.payload }
        case CREATE_BANE_LIMIT:
            var getBaneLimitslist = Array.from(state.baneLimitslist)
            getBaneLimitslist.push(action.payload)
            return { ...state, baneLimitslist: getBaneLimitslist, isLoadingBaneLimits: false }
        case EDIT_BANE_LIMIT:
            var index = action.payload.index
            var baneLimit = action.payload.baneLimit
            var getBaneLimitslist = Array.from(state.baneLimitslist)
            getBaneLimitslist.splice(index, 1, baneLimit)
            return { ...state, baneLimitslist: getBaneLimitslist, isLoadingBaneLimits: false }
        case DELETE_BANE_LIMIT:
            var getBaneLimitslist = Array.from(state.baneLimitslist)
            getBaneLimitslist.splice(action.payload, 1)
            return { ...state, isLoadingBaneLimits: false, baneLimitslist: getBaneLimitslist }
        case GET_ACTUAL_LIMIT_BANE:
            return { ...state, baneActualLimit: action.payload, isLoadingBaneLimits: false }
        case ACTUAL_BANE_LIMIT:
            var listBaneLimits = Array.from(state.baneLimitslist)
            var oldBaneLimit = { strikeQuantity: action.payload.baneActualLimit.strikeQuantity, banDays: action.payload.baneLimit.limitToClose.banDays }
            var newBaneLimit = { strikeQuantity: action.payload.baneLimit.strikeQuantity }
            console.log()
            listBaneLimits.push(oldBaneLimit)
            return { ...state, baneActualLimit: newBaneLimit, baneLimitslist: listBaneLimits, isLoadingBaneLimits: false }
        case IS_LOADING_LIST_REPORTS:
            return { ...state, isLoadingListReports: true }
        case LIST_REPORTS:
            return { ...state, isLoadingListReports: false, listOfReports: action.payload }
            case ClEAN_LIST_REPORTS:
                return { ...state, isLoadingListReports: false, listOfReports: [] }
        case CHANGE_REPORT:
            var removeReport = state.listOfReports.filter(report => report._id != action.payload)
            return { ...state, isLoadingListReports: false, listOfReports: removeReport }

        case IS_LOADING_LIST_REPORTS_CONTENT:
            return { ...state, isLoadingListReportsContent: true }
        case LIST_REPORTS_CONTENT:
            return { ...state, isLoadingListReportsContent: false, listOfReportsContent: action.payload }
        case CHANGE_REPORT_CONTENT:
            var removeReport = state.listOfReportsContent.filter(report => report._id !== action.payload)
            return { ...state, isLoadingListReports: false, listOfReportsContent: removeReport }
        case IS_LOADING_LIST_REPORTS_COMMUNITIES:
            return { ...state, isLoadingListReportsCommunities: true }
        case LIST_REPORTS_COMMUNITIES:
            return { ...state, isLoadingListReportsCommunities: false, listReportsCommunities: action.payload }
        case CHANGE_REPORT_COMMUNITY:
            var removeReport = state.listReportsCommunities
            removeReport.splice(action.payload, 1)
            return { ...state, isLoadingListReportsCommunities: false, listReportsCommunities: removeReport }
        default:
            return state

    }
}